import { Component, OnInit } from '@angular/core';
import { SuperClass } from '../../../../superclass/SuperClass';
import { BreadcrumbService } from '../../../../breadcrumb.service';
import { DashboardDataService } from '../../../../services/dashboard-data.service';
import { ClientsService } from '../../../../services/clients/clients.service';
import { WsService } from '../../../../services/websocket/WsService';
import { HttpClient } from '@angular/common/http';
import { CookieService } from 'ngx-cookie-service';
import { RouterConst } from '../../../../globals/RoutersConst';
import { Globals } from '../../../../globals/Globals';
import { SentMessage } from './sent-message.model';

@Component({
  selector: 'app-sent-messages',
  templateUrl: './sent-messages.component.html',
  styleUrls: ['./sent-messages.component.css'],
})
export class SentMessagesComponent extends SuperClass {
  public messages: SentMessage[];

  constructor(
    private breadcrumbService: BreadcrumbService,
    private dashboardDataService: DashboardDataService,
    private clientsService: ClientsService,
    private wsService: WsService,
    private httpClient: HttpClient,
    private cookiesService: CookieService,
  ) {
    super(
      clientsService,
      wsService,
      dashboardDataService,
      httpClient,
      cookiesService,
    );

    this.breadcrumbService.setItems([
      { label: 'Dashboards' },
      { label: 'Reporting' },
      {
        label: 'Sent Messages',
        routerLink: [{ outlets: { sub: [RouterConst.SENT_MESSAGES] } }],
      },
    ]);
  }

  selectRow(e) {}

  getDate(date) {
    return new Date(date);
  }

  reloadData(): void {
    this.http_getSentMessages((data: any) => {
      if (data.result === Globals.RESPONSE_RESULT_SUCCESS) {
        this.messages = data.payload;
      }
    });
  }

  getWebSocketIdentifier(): string {
    return undefined;
  }
}



// WEBPACK FOOTER //
// /home/sgurin/IdeaProjects/cosy/cp-builder/src/app/components/dashboards/reporting/sent-messages/sent-messages.component.ts